import { Vendor } from '@melio/platform-api';
import { useConfig } from '@melio/platform-provider';
import { forwardRef } from '@melio/platform-utils';

import { RppsVendorDetailsForm } from './forms/RppsVendorDetailsForm/RppsVendorDetailsForm';
import { VendorDetailsFormInnerProps } from './forms/types';
import { VendorDetailsExtendedUnmanagedForm } from './forms/VendorDetailsExtendedUnmanagedForm/VendorDetailsExtendedUnmanagedForm';
import { VendorDetailsMangedByFiservForm } from './forms/VendorDetailsMangedByFiservForm/VendorDetailsMangedByFiservForm';
import { VendorDetailsUnmanagedForm } from './forms/VendorDetailsUnmanagedForm/VendorDetailsUnmanagedForm';

export type VendorDetailsFormProps = VendorDetailsFormInnerProps & {
  isRPPSVendor?: boolean;
  managedBy?: Vendor['managedBy'];
};

export const VendorDetailsForm = forwardRef<VendorDetailsFormProps, 'form'>(
  ({ isRPPSVendor, managedBy, ...props }, ref) => {
    const {
      settings: {
        vendor: { collectedDetails: vendorCollectedDetails },
      },
    } = useConfig();

    if (isRPPSVendor) {
      return <RppsVendorDetailsForm ref={ref} {...props} />;
    }

    if (managedBy === 'fiserv') {
      return <VendorDetailsMangedByFiservForm ref={ref} {...props} />;
    }

    if (vendorCollectedDetails === 'extended') {
      return <VendorDetailsExtendedUnmanagedForm ref={ref} {...props} />;
    }

    return <VendorDetailsUnmanagedForm ref={ref} {...props} />;
  },
);
